<template lang="pug">
    v-container(grid-list-md v-if="content" )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg5 md5 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-file-document-outline
            v-flex(lg4 md4 xs12)
                v-text-field(dense v-model="customerId" label="No Pelanggan" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg12 md12 xs12 v-if="content.bills")
                v-combobox(multiple v-model="bills" label="Detail Tagihan" append-icon small-chips class="tag-input" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
        v-layout(wrap)
            v-flex(lg3 md3 xs12)
                f-decimalbox(v-model="amount" label="Nominal" readonly :template="true")
            v-flex(lg3 md3 xs12 v-if="penalty")
                f-decimalbox(v-model="penalty" label="Denda" readonly :template="true")
            v-flex(lg2 md2 xs12)
                f-decimalbox(v-model="fee" label="Biaya Admin" readonly :template="true")
            v-flex(lg3 md3 xs12)
                f-decimalbox(v-model="total" label="Total" readonly :template="true")
                
</template>
<script>
export default {
    name: "FPaymentContent",
    props: ["content", "request", "transaction"],
    computed: {
        source() {
        return this.$options.filters.accountformat(this.content.source)+ " - " + this.content.sourceName;
        },
        customerId(){
            return this.content.references.join(" ") + 
                (this.content.info ? this.content.info.customerName ? 
                (" - " + this.content.info.customerName) : "" : "");
        },
        penalty(){
            if (this.content.bills && this.content.bills.length > 0) {
                let pen = this.content.bills.map(m => (m.otherInfo && m.otherInfo.denda) ? m.otherInfo.denda : 0).reduce((a,b) => a + b);
                return pen > 0 ? pen : null;
            }else{
                return null;
            }
        },
        amount(){
            return this.penalty ? (Number(this.content.summary.amount) - Number(this.penalty)) : this.content.summary.amount;
        },
        fee(){
            return this.content.summary.feeSourceAccount ? 0 : this.content.summary.fee;
        },
        total(){
            return this.content.summary.feeSourceAccount ? this.content.summary.amount : this.content.summary.totalAmount;
        },
        bills(){
          return this.content.bills.map(m => {
            var other = "";
            if(this.content.productCode=="BPJSTK_EPS"){
              other=(m.otherInfo && m.otherInfo.denda) ? (" (Denda Rp. " + this.$options.filters.decimalformat(m.otherInfo.denda) + ")") : "";
              var jht= (m.otherInfo && m.otherInfo.jht) ? (" - JHT Rp. " + this.$options.filters.decimalformat(m.otherInfo.jht) + " ") : ""
              var jkk= (m.otherInfo && m.otherInfo.jkk) ? (" - JKK Rp. " + this.$options.filters.decimalformat(m.otherInfo.jkk) + " ") : ""
              var jkm= (m.otherInfo && m.otherInfo.jkm) ? (" - JKM Rp. " + this.$options.filters.decimalformat(m.otherInfo.jkm) + " ") : ""
              var jkp= (m.otherInfo && m.otherInfo.jkp) ? (" - jp Rp. " + this.$options.filters.decimalformat(m.otherInfo.jkp) + " ") : ""
              return (m.billNumber ? m.billNumber :
                      m.billDate ? m.billDate :
                          m.billName ? m.billName : "") + " - Rp. "
                  +this.$options.filters.decimalformat(m.amount) + other+jht+jkk+jkm+jkp;
            }
            other=(m.otherInfo && m.otherInfo.denda) ? (" (Denda Rp. " + this.$options.filters.decimalformat(m.otherInfo.denda) + ")") : "";
            return (m.billNumber ? m.billNumber :
                    m.billDate ? m.billDate :
                        m.billName ? m.billName : "") + " - Rp. " +
                this.$options.filters.decimalformat(m.amount) + other;
          });

        }
    }
};
</script>
<style>
.tag-input .theme--light.v-chip:not(.v-chip--active) {
    background: black !important;
    color: white !important;
}
</style>